// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"form_wrapper__1OdXV","error":"form_error__3nHAM","containerForm":"form_containerForm__1tHxZ","form":"form_form__3aNPR","formWrapper":"form_formWrapper__1ichY"};